<app-filters-sidebar-filter label="">
  <header>Warranty</header>
  <app-dual-range label="" [max]="100000" [step]="5000" [formatter]="formatMileage" (rangeChange)="rangeChange($event)"></app-dual-range>
</app-filters-sidebar-filter>
